// @todo migration alias
export { useAddressFromQuery } from "@looksrare/utils";
